
import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { debugL } from '../../custom'; 
import { decimalToHoursAndMinutes } from '../Utils'; 
import { allStartTimeOptions, allPickupTimeOptions } from './OrderConstants.js';

const db = app.firestore();
const weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function normalizeDateToNoon(date) {
  const normalizedDate = new Date(date);
  normalizedDate.setHours(12, 0, 0, 0);
  return normalizedDate;
}

function extractUniqueValues(array, comparator) {
  const uniqueValues = [];

  array.forEach(item => {
      const isUnique = !uniqueValues.some(existingItem => comparator(existingItem, item));

      if (isUnique) {
          uniqueValues.push(item);
      }
  });

  return uniqueValues;
}

String.prototype.replaceAt = function(index, replacement) {
  return this.substring(0, index) + replacement + this.substring(index + replacement.length);
}

export function delay(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

export function formatPrice(price) {
  const priceStr = "" + Math.round(price);
  return priceStr.substr(0, priceStr.length-2) + "." + priceStr.substr(priceStr.length-2) + " €";
}

export function areDatesEqual(date1, date2) {
  return normalizeDateToNoon(date1).getTime() === normalizeDateToNoon(date2).getTime();
}

export function isDateInArray(date, array) {
  const normalizedDate = normalizeDateToNoon(date);
  return array.some(item => areDatesEqual(normalizedDate, item));
}

export async function getAllTimeSlots() {
  try {
    const timeSlotsAll = (await db.collection('timeSlots').orderBy("startTime", "asc").get()).docs;
  
    return timeSlotsAll.map(function(x) {
      const ts = x.data();
      return ts;
    })
    .sort((a, b) => a.startTime - b.startTime);
  } catch (e) {
    console.log("ERROR in get orders");
    console.log(e.message);
    return [];
  }
}

export function computeTimeSlots(allTimeSlots, weight, city, tsType, fullSupport, allRetailerPermissions) {
  
  debugL > 0 && console.log("computeTimeSlots");
  let timeSlots = allTimeSlots;

  // console.log("before filtering");
  // console.log(timeSlots);

  // VALIDATE TIMESLOT IS OPEN or FULL SUPPORT
  timeSlots = timeSlots.filter(function(ts) {

    // for express return true for all time slots;
    // if(tsType == "0" || fullSupport) {
    if(tsType == "0") {
       return true;
    }

    if (ts.status !== "open" && !fullSupport) {
      return false;
    }

    // TODO move this to the right place
    const startTime = ts.startTime.toDate();
    const day = startTime.getDay();

    if (day == 6) {
      if(
        (allRetailerPermissions.timePermissions && tsType == "1" && allRetailerPermissions.timePermissions.includes("Sat")) ||
        (allRetailerPermissions.timePermissions2H && tsType == "2" && allRetailerPermissions.timePermissions2H.includes("Sat")) ||
        (allRetailerPermissions.timePermissions3H && tsType == "3" && allRetailerPermissions.timePermissions3H.includes("Sat"))
      ){
        return true;
      } else {
        return false;
      }
    }
    
    if (day == 0) {
      if(
        (allRetailerPermissions.timePermissions && tsType == "1" && allRetailerPermissions.timePermissions.includes("Sun")) ||
        (allRetailerPermissions.timePermissions2H && tsType == "2" && allRetailerPermissions.timePermissions2H.includes("Sun")) ||
        (allRetailerPermissions.timePermissions3H && tsType == "3" && allRetailerPermissions.timePermissions3H.includes("Sun"))
      ){
        return true;
      } else {
        return false;
      }
    }

    return true;
  });
  // console.log("timeSlots after retailerId filter");
  // console.log(timeSlots.map(ts => ts.startTime.toDate()));

  // KEEP ONLY TIMESLOTS OF THE GIVEN CITY (no afternoons for zone 3)
  if(city) {
    timeSlots = timeSlots.filter(function(ts) {
      const startTime = ts.startTime.toDate();
      const hour = startTime.getHours();
      
      // console.log(hour);
      // console.log(city);
      
      return ( 
        hour <= 13 || ![
          "Boulogne-Bilancourt", 
          "Puteaux", 
          "Courbevoie", 
          "Asnières-sur-Seine", 
          "Nanterre", 
          "La-Garenne-Colombes", 
          "Bois-Colombes",
        ].includes(city)
      )     
    });
  }

  timeSlots = timeSlots.filter(function(ts) {
      const startTime = ts.startTime.toDate();
      const hour = startTime.getHours();
      
      // console.log(hour);
      // console.log(city);
      
      return ( 
        hour >= 13 || weight >= 10 || (allRetailerPermissions.weightPermissions && allRetailerPermissions.weightPermissions.includes("S7H"))
      )     
    });

  debugL > 1 && console.log("after filtering");
  debugL > 1 && console.log(timeSlots.map(ts => ts.startTime.toDate()));

  debugL > 0 && console.log("timeSlots.length",timeSlots.length);
  // debugL > 0 && console.log("timeSlots",timeSlots.map(ts => ts.startTime.toDate()));

  return timeSlots;
}

export function computeDays(timeSlots) {
  debugL > 1 && console.log("computeDays");
  const dates = timeSlots.map((ts) => normalizeDateToNoon(ts.startTime.toDate()));

  const days = extractUniqueValues(dates, areDatesEqual);
  debugL > 1 && console.log(days);

  return days;
}

export function computeLocationTimeSlots(timeSlots, locations) {
  
  debugL > 1 && console.log("computeLocationTimeSlots");
  // console.log("allTimeSlots");
  // console.log(allTimeSlots.map(ts => ts.startTime.toDate()));

  // KEEP ONLY TIMESLOTS OF THE DAY
  for(let location of locations) {
    if(location) {
      const recurrentSchedule = location.recurrentSchedule; 
      const processedHolidays = location.processedHolidays;
      const exceptionalDays = location.exceptionalDays.map(e => ({
        morningStart: e.morningStart,
        morningEnd: e.morningEnd,
        afternoonStart: e.afternoonStart,
        afternoonEnd: e.afternoonEnd,
        day : new Date(e.day*1000)
      }));
  
      timeSlots = timeSlots.filter(function(ts) {
        
        const startTimeDate = ts.startTime.toDate();
        const hours = startTimeDate.getHours();
  
        const date = startTimeDate.getDate();
        const month = startTimeDate.getMonth();
        const dayNumber = startTimeDate.getDay();
        const zeroHoursDate = new Date(startTimeDate); 
        zeroHoursDate.setHours(0);
  
        // console.log("startTime");
        // console.log(startTime);
        //filter based on exceptional days
        for (let eday of exceptionalDays) {
            if (eday.day.getTime() === zeroHoursDate.getTime()) {
                if( (hours < eday.morningStart | hours >= eday.morningEnd) &&
                    (hours < eday.afternoonStart | hours >= eday.afternoonEnd) ) {
                        return false;
                } else {
                    return true;
                }
            }
        }
  
        // filter based on holidays
        for (let holiday of processedHolidays) {
            if (holiday.day == date && holiday.month == month+1) {
                return false;
            }
        }
  
        // filter based on recurrentSchedule
        let day = weekDays[dayNumber];
        let daySchedule = recurrentSchedule[day];
        // console.log("daySchedule");
        // console.log(daySchedule);
        if( (hours < daySchedule.morningStart | hours >= daySchedule.morningEnd) &&
            (hours < daySchedule.afternoonStart | hours >= daySchedule.afternoonEnd) ) {
                return false;
        } else {
            return true;
        }
      });    
    }
  
    debugL > 1 && console.log(timeSlots);
  }

  return timeSlots;
}

export function computeLocationDays(locationTimeSlots) {
  debugL > 1 && console.log("computeLocationDays");
  const dates = locationTimeSlots.map((ts) => normalizeDateToNoon(ts.startTime.toDate()));

  const locationDays = extractUniqueValues(dates, areDatesEqual);
  debugL > 1 && console.log(locationDays);

  return locationDays;
}

export function computeTimeSlotHours(timeSlots, tsDay) {

  debugL > 1 && console.log("computeTimeSlotHours");
  // console.log("allTimeSlots");
  // console.log(allTimeSlots.map(ts => ts.startTime.toDate()));

  // KEEP ONLY TIMESLOTS FOR THE GIVEN DAY
  if(tsDay) {
    // console.log("tsDay");
    // console.log(tsDay);
    const tsDayDate = tsDay.getDate();
    const tsDayMonth = tsDay.getMonth();
    const tsDayYear = tsDay.getYear();

    timeSlots = timeSlots.filter(function(ts) {
      const startTime = ts.startTime.toDate();
      const date = startTime.getDate();
      const month = startTime.getMonth();
      const year = startTime.getYear();

      // console.log(tsDayDate, tsDayMonth, tsDayYear);
      if (date === tsDayDate && month === tsDayMonth && year === tsDayYear) {
        // console.log("True", date, month, year);
        return true;
      } else {
        // console.log("False", date, month, year);
        return false;
      }
    });
    // console.log("timeSlots after tsDay filter");
    // console.log(timeSlots.map(ts => ts.startTime.toDate()));
  }

  // console.log("timeSlots");
  // console.log(timeSlots.map(ts => ts.startTime.toDate()));
  
  // TRANSFORM THEM INTO TIMESLOT HOURS
  // this variable and function should be renamed to timeSlotHours and not startTimes
  const timeSlotHours = timeSlots.map(function(ts) {
    const startTime = ts.startTime.toDate();
    const hours = startTime.getHours();
    return "" + hours;
  });

  debugL > 1 && console.log(timeSlotHours);

  return timeSlotHours;
}

// TODO 1 : process the case of location hub / other.
// TODO 2 : check if better to compute from locationTimeSlots
export function computeLocationTimeSlotHours(timeSlotHours, locations, tsDay) {

  debugL > 1 && console.log("computeLocationTimeSlotHours");

  // console.log("------- timeSlotHours");
  // console.log(timeSlotHours);
  // console.log("------- location");
  // console.log(location);
  // console.log("------- tsDay");
  // console.log(tsDay);

  // VALIDATE STORE IS OPEN (NOT ANYMORE)
  let locationTimeSlotHours = timeSlotHours;

  for (let location of locations) {
    if(location) {
      const recurrentSchedule = location.recurrentSchedule; 
      const processedHolidays = location.processedHolidays;
      const exceptionalDays = location.exceptionalDays.map(e => ({
        morningStart: e.morningStart,
        morningEnd: e.morningEnd,
        afternoonStart: e.afternoonStart,
        afternoonEnd: e.afternoonEnd,
        day : new Date(e.day*1000)
      }));
  
      locationTimeSlotHours = locationTimeSlotHours.filter(function(tsHour) {
        const hours = tsHour;
  
        const date = tsDay.getDate();
        const month = tsDay.getMonth();
        const dayNumber = tsDay.getDay();
        const zeroHoursDate = new Date(tsDay); 
        zeroHoursDate.setHours(0);
  
        // console.log("startTime");
        // console.log(startTime);
        //filter based on exceptional days
        for (let eday of exceptionalDays) {
            if (eday.day.getTime() === zeroHoursDate.getTime()) {
                if( (hours < eday.morningStart | hours >= eday.morningEnd) &&
                    (hours < eday.afternoonStart | hours >= eday.afternoonEnd) ) {
                        return false;
                } else {
                    return true;
                }
            }
        }
  
        // filter based on holidays
        for (let holiday of processedHolidays) {
            if (holiday.day == date && holiday.month == month+1) {
                return false;
            }
        }
  
        // filter based on recurrentSchedule
        let day = weekDays[dayNumber];
        let daySchedule = recurrentSchedule[day];
        // console.log("daySchedule");
        // console.log(daySchedule);
        if( (hours < daySchedule.morningStart | hours >= daySchedule.morningEnd) &&
            (hours < daySchedule.afternoonStart | hours >= daySchedule.afternoonEnd) ) {
                return false;
        } else {
            return true;
        }
      });    
    }
  }

  debugL > 1 && console.log(locationTimeSlotHours);

  return locationTimeSlotHours;
}

export function computeStartTimeOptions(timeSlotHours, tsType, allRetailerPermissions) {

  debugL > 1 && console.log("computeStartTimeOptions");

  let retailerPermissions = allRetailerPermissions.timePermissions;
  if(tsType == "3") {
    retailerPermissions = allRetailerPermissions.timePermissions3H;
  } else if(tsType == "2") {
    retailerPermissions = allRetailerPermissions.timePermissions2H;
  }  

  // KEEP ONLY STARTTIMEOPTIONS (time window options) THAT ARE VALID : 
  // 1) STARTTIMEOPTIONS WITH THE CHOSEN TIMESLOTTYPE (size of time window)
  // 2) AND STARTTIME SHOULD BE IN RETAILER TIMESLOTPERMISSIONS (or TIMESLOTPERMISSIONS3H)
  // 3) AND ALL HOURS OPEN FOR THE CHOSEN TIME WINDOW (defined by TimeSlotType and StartTime)
  const startTimeOptions = allStartTimeOptions.filter((option) => {

    // console.log("option", option);

    // Filtering based on criteria 1)
    if(option.tsType != tsType) {
      // console.log("FALSE A");
      // console.log("tsType", tsType);
      return false;
    }
    
    const [optionHours, optionMinutes] = decimalToHoursAndMinutes(option.value);
    let nbHours = parseInt(tsType);
    if(optionMinutes != 0) {
      nbHours += 1;
    }

    // Filtering based on criteria 2)    
    let hourStr = "" + optionHours; 
    if(hourStr.length == 1) {
      hourStr = "0" + hourStr;
    }
    
    if (!retailerPermissions || !retailerPermissions.includes(hourStr)) {
      // console.log("FALSE B");
      return false;
    }
    
    // Filtering based on criteria 3)
    for(let h = 0; h < nbHours; h++) {
      const timeSlotHourStr = "" + (optionHours + h);
      if(!timeSlotHours.includes(timeSlotHourStr)) {
        // console.log("FALSE C");
        return false;
      }
    }

    // console.log("TRUE");
    return true;
  });

  debugL > 1 && console.log(startTimeOptions);

  return startTimeOptions;
}

export function computeLocationStartTimeOptions(startTimeOptions, locationTimeSlotHours, tsType) {

  debugL > 1 && console.log("computeLocationStartTimeOptions");

  // KEEP ONLY STARTTIMEOPTIONS (time window options) THAT ARE VALID : 
  // 3) AND ALL HOURS OPEN FOR THE CHOSEN TIME WINDOW (defined by TimeSlotType and StartTime)
  const locationStartTimeOptions = startTimeOptions.filter((option) => {
    
    // Filtering based on criteria 3)
    const [optionHours, optionMinutes] = decimalToHoursAndMinutes(option.value);
    let nbHours = parseInt(tsType);
    if(optionMinutes != 0) {
      nbHours += 1;
    }

    for(let h = 0; h < nbHours; h++) {
      const timeSlotHourStr = "" + (optionHours + h);
      if(!locationTimeSlotHours.includes(timeSlotHourStr)) {
        return false;
      }
    }

    return true;
  });

  debugL > 1 && console.log(locationStartTimeOptions);

  return locationStartTimeOptions;
}

export function computePickupTimeOptions(timeSlotHours, startTime) {

  debugL > 1 && console.log("computePickupTimeOptions");
  // console.log("allTimeSlots");
  // console.log(allTimeSlots.map(ts => ts.startTime.toDate()));
  
  const lastHour = parseFloat(startTime);
  const firstHour =  lastHour < 13 ? 7 : 13;

  // KEEP ONLY PickupTimes THAT ARE VALID : 
  
  const pickupTimeOptions = allPickupTimeOptions.filter((option) => {
    
    const optionHour = parseFloat(option.value);

    // console.log("firstHour", firstHour);
    // console.log("optionHour", optionHour);
    // console.log("lastHour", lastHour);

    if(optionHour >= firstHour && optionHour <= lastHour) {
      return true;
    } else {
      return false;
    } 
  });

  debugL > 1 && console.log(pickupTimeOptions);

  return pickupTimeOptions;
}

export function computeLocationPickupTimeOptions(pickupTimeOptions, locationTimeSlotHours) {

  debugL > 1 && console.log("computeLocationPickupTimeOptions");
  // console.log("allTimeSlots");
  // console.log(allTimeSlots.map(ts => ts.startTime.toDate()));

  // console.log("pickupTimeOptions");
  // console.log(pickupTimeOptions);
  
  // KEEP ONLY pikcup time options THAT ARE VALID for location
  const locationPickupTimeOptions = pickupTimeOptions.filter((option) => {
    
    // TODO REMOVE THIS ROUNDING AFTER FIXING LOCATIONS
    const decimalPikcupTime = option.value;
    return locationTimeSlotHours.includes(""+Math.floor(decimalPikcupTime));
    
  });

  debugL > 1 && console.log(locationPickupTimeOptions);

  return locationPickupTimeOptions;
}

export function isShopifyB2C(order) {
  return order.retailerOrderType == "shopify-b2c";
}

export function canBeSetCanceled(order) {
  return ["wait_min_ts"].includes(order.orderStatus) || (["paid"].includes(order.orderStatus) && !isShopifyB2C(order));
}

export function canBeSetWaiting(order) {
  return (["paid"].includes(order.orderStatus) && !isShopifyB2C(order));
}

export function canBeSetReady(order)  {
  return (["wait_min_ts"].includes(order.orderStatus)) && (order.timeSlot || isShopifyB2C(order));
} 

export function canBeSetCanceledInGroup(order) {
  return canBeSetCanceled(order); // can't be the case || order.orderStatus == "canceled";
}
export function canBeSetWaitingInGroup(order) {
  return canBeSetWaiting(order) || order.orderStatus == "wait_min_ts";
}
export function canBeSetReadyInGroup(order) {
  return canBeSetReady(order) || order.orderStatus == "paid" || order.orderStatus == "wait_ts" ;
}